// export default {
//     setStore: function (k, v) {
//         localStorage.setItem(k, v)
//     },
//     getStore: function (k) {
//         localStorage.getItem(k);
//     },
//     removeStore: function (k) {
//         localStorage.removeItem(k);
//     },
//     updateStore: function (k, v) {
//         localStorage.setItem(k, v);
//     }
// }

export function setStore(k, v) {
    localStorage.setItem(k, JSON.stringify(v))
}

export function getStore(k) {
    let u = JSON.parse(localStorage.getItem(k))
    return u;
}

export function removeStore(k) {
    localStorage.removeItem(k)
}
export function updateStore(k, v) {
    localStorage.setItem(k, v)
}